import { render, staticRenderFns } from "./listsurattugas.vue?vue&type=template&id=4de6f563&"
import script from "./listsurattugas.vue?vue&type=script&lang=js&"
export * from "./listsurattugas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports